/* eslint-disable import/no-unresolved */
import React from "react";
import { useSelector } from "react-redux";
import buildConfig from "@regional/config/build.config.json";
import headerLogo from "@regional/img/brand-logo.png";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";
import { white } from "../../../../theme/color.constants";

const Styled = styled(Box, {
  shouldForwardProp: (prop) => prop !== "props",
})(({ theme }) => ({
  textDecoration: "none",
  position: "relative",
  height: "100%",
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
  paddingLeft: "0.9375rem",
  "&:focus": {
    backgroundColor: white,
  },
  [theme.breakpoints.down("sm")]: {
    "& img": {
      maxWidth: undefined,
    },
  },
  "& .textContainer": {
    margin: "0.1875rem 0 0 0.375rem",
    display: "grid",
    "& .MuiTypography-root": {
      lineHeight: "1.2em",
      fontWeight: "500",
      textTransform: "uppercase",
      maxWidth: "10.375rem",
    },
  },

  variants: [
    {
      props: ({ props }) => props.title && props.user,
      style: { paddingLeft: "0.3125rem" },
    },
    {
      props: ({ props }) => props.title,
      style: {
        [theme.breakpoints.down("sm")]: {
          "& img": { maxWidth: "3.4375rem !important" },
        },
      },
    },
  ],
}));
function HeaderLogo() {
  const {
    showLogoTitle,
    logoImgAlt,
    logoTextPrimary,
    logoTextSecondary,
    logoClass,
  } = buildConfig;
  const user = useSelector((state) => state.auth.userData);
  const colorMap = {
    default: "#4662b4",
    "al-amcc": "#506d57",
    "usvi-ocr": "#506d57",
  };

  const logoClassMap = {
    default: {},
    wvLogo: {
      paddingLeft: 0,
    },
  };
  const logoStyles = logoClassMap[logoClass] || logoClassMap.default;

  const textColor =
    colorMap[process.env.REACT_APP_COMPLIA_INSTALL] || colorMap.default;

  const props = { title: showLogoTitle, user };
  const linkToHomePage = user ? "/licenses" : "/login";
  return (
    <Styled
      props={props}
      component={Link}
      to={linkToHomePage}
      sx={{ ...logoStyles }}
      aria-label={logoImgAlt || "Home"}
    >
      <img src={headerLogo} alt={logoImgAlt} />
      {showLogoTitle && (
        <Box
          className="textContainer"
          sx={{
            "& .MuiTypography-root": {
              fontSize: { xs: ".69rem", sm: "0.8rem", lg: "0.75rem" },
              color: textColor,
            },
            "& .MuiTypography-root:first-of-type": logoTextPrimary
              ? {
                  fontSize: { xs: ".6rem", sm: "0.7rem" },
                  pt: { lg: 0, md: "2px", sm: 0, xs: 0 },
                  mb: { lg: "2px", sm: "2px", xs: "4px " },
                  width: { xs: "95%", md: "100%" },
                }
              : {},
            "& .MuiTypography-root:nth-of-type(2)": {
              whiteSpace: "pre-wrap",
              pt: "0.075rem",
              width: { xs: "95%", md: "100%" },
            },
          }}
        >
          <Typography variant="subtitle2" component="span">
            {logoTextPrimary}
          </Typography>
          <Typography variant="subtitle1" component="span">
            {logoTextSecondary}
          </Typography>
        </Box>
      )}
    </Styled>
  );
}

export default HeaderLogo;
